enum FlexGridTableRowTypeEnum {
    Group,
    Aggregate,
    Main,
    Subcomponent,
}

export default FlexGridTableRowTypeEnum;
